import "/usr/local/share/.config/yarn/global/node_modules/@vuepress/core/lib/node/internal-plugins/style/client.js"
export default {}